module.exports = {
  username: 'Username',
  password: 'Password',
  name: 'Name (Not visible to customers)',
  search: 'Search',
  overview: 'Overview',
  generate: 'Generate',
  currency: 'Currency',
  status: 'Status',
  modified: 'Modified On',
  created: 'Created On',
  actions: 'Actions',
  filter: 'Filter for company',
  catalogFilter: 'Filter for catalogs',
  active: 'Active',
  inactive: 'Inactive',
  phone: 'Phone',
  email: 'Email',
  externalID: 'External ID',
  externalIDres: 'External Resource ID',
  testMode: 'Enable Test Mode',
  addressLine: 'Address line',
  locality: 'Locality',
  townCity: 'Town/City',
  country: 'Country',
  postalcode: 'Postal Code',
  createCompany: 'Create company',
  editCompany: 'Edit company',
  companyDomain: 'Company Domain',
  type: 'Type',
  company: 'Company',
  companyName: 'Company Name',
  companyId: 'Company ID',
  propKey: 'Property Key',
  propValue: 'Property Value',
  fromDate: 'From Date',
  toDate: 'To Date',
  errorMessage: 'Error Message',
  language: 'Select Language',
  multipleTables: 'Do you want to create multiple tables?',
  sequenceNumber: 'Displace sequence',
  minDelivery: 'Min Delivery Amount',
  sendToMoon: 'Do you want to send web shop orders to Moon?',
  sendEmail: 'Sending Email Address',
  sendBCC: 'Order Recipients Email Addresses (separated by ,)',
  prefix: 'Prefix',
  postfix: 'Postfix',
  numberOfPrints: 'Number of Prints',
  numberOfTables: 'Number of Tables',
  payGateway: 'Payment Gateway',
  merchantId: 'Merchant ID',
  preSharedKey: 'Pre Shared Key',
  data: 'Data',
  url: 'URL',
  moonUrl: 'Moon URL',
  macAddress: 'Mac Addresses',
  queueUrl: 'Moon Queue URL',
  publicKeySun: 'Sun Public Key',
  privateKeySun: 'Sun Private Key',
  publicKeyMoon: 'Moon Public Key',
  instanceId: 'Instance ID',
  totalAmount: 'Total Amount',
  backup: 'Backup Interval (In Hours)',
  fetchConf: 'Fetch Configuration Frequency (In Min.)',
  paymentTypes: 'Payment Types',
  tipTax: 'Tip Tax Rate',
  left: 'Left',
  right: 'Right',
  defLang: 'Default Language',
  cuisines: 'Cuisines',
  maxDist: 'Max Delivery Distance',
  delPostal: 'Delivery Postal Codes (separated by ,)',
  updatePassword: 'Set/Update password',
  chargeTax: 'Delivery Charges Tax Rate',
  chargeType: 'Delivery Charge Type',
  delChargePerMile: 'Delivery Charge Per Mile',
  chargesPerMile: 'Charges Per Mile',
  noCharge: 'No Delivery Charge',
  chargeByMile: 'Charge By Miles',
  chargeByInvoice: 'Charge By Invoice Amount',
  payIntegModule: 'Activate Moon payment integration',
  orderPrint: 'Enable complete order print?',
  enquiryContact: 'Enable contact form on webpage',
  enquiryReser: 'Enable reservation form on webpage?',
  minPersons: 'Min # of Persons',
  maxPersons: 'Max # of Persons',
  sunday: 'SUNDAY',
  monday: 'MONDAY',
  tuesday: 'TUESDAY',
  wednesday: 'WEDNESDAY',
  thursday: 'THURSDAY',
  friday: 'FRIDAY',
  saturday: 'SATURDAY',
  concurrent: 'Concurrent Users',
  sunLicense: 'Sun License System Version',
  moonInstID: 'Moon Instance ID',
  printerName: 'Printer Name',
  ipAddress: 'IP Address',
  portNumber: 'Port Number',
  maxRetriesOnErrors: 'Max Retries On Errors',
  maxTransactionDuration: 'Max Transaction Duration (in sec)',
  notes: 'Notes',
  controlledByMoon: 'Do you want to assign this printer to Moon?',
  pdfPrinter: 'PDF Printer',
  printServerName: 'Print Server Name',
  key: 'Key',
  records: '# Records For Printing',
  holder: 'Account Holder Name',
  maxDiscount: 'Max Discount Percentage',
  lowerCase: 'Username should be lowercase',
  corporationName: 'Corporation Name',
  templateName: 'Template Name',
  fontHeight: 'Font Height',
  fontStyle: 'Font Style',
  mainawayTemplate: 'Mainaway Template',
  content: 'Content',
  month: 'Month',
  year: 'Year',
  january: 'January',
  february: 'February',
  march: 'March',
  april: 'April',
  may: 'May',
  june: 'June',
  july: 'July',
  august: 'August',
  september: 'September',
  october: 'October',
  november: 'November',
  december: 'December',
  unpaidBillTemplate: 'Unpaid Bill Template',
  taxTemplate: 'Tax Template',
  itemTemplate: 'Item Template',
  labelTemplate: 'Label Template',
  kitchenTemplate: 'Kitchen Template',
  driverTemplate: 'Driver Template',
  licenseSyncStatus: 'License Sync Status',
  daily: 'Daily',
  monthly: 'Monthly',
  monthlyAgg: 'Monthly Aggregate',
  noService: 'No Service Charge',
  percOfTotal: 'Charge by Percentage of Total',
  serviceTaxRate: 'Service Charge Tax Rate',
  percentage: 'Percentage',
  configUpdates: 'Config Updates',
  planetType: 'Planet Type',
  planetInstName: 'Planet Instance Name',
  companyDataUpdated: 'Company Data Updated',
  langMapforPrintCat: 'Languages Mapped For Printer Categories',
  ruleName: 'Rule Name',
  amountOfPersons: 'Amount of Persons',
  minAmount: 'Minimum Amount of',
  voucherCode: 'Voucher Code',
  startTime: 'Start Time',
  endTime: 'End Time',
  discountAmount: 'Discount Amount',
  discountPercent: 'Discount Percent',
  discountRules: 'Discount Rules',
  discountRuleNames: 'Discount Rule Names',
  refreshCatalog: 'Refresh Catalog',
  yourPassword: 'Your password is: ',
  description: 'Description',
  showActive: 'Show Active Only',
  swithcCode: 'Table Switch Code',
  swithcCodeHint: 'Table Switch Code must be 4 digits',
  auditDirection: 'Audit Direction',
  domainType: 'Domain Type',
  tableIdleTimeInMinutes: 'Table Idle Time (In Min)',
  align: 'Align',
  idForS3: 'ID for S3 Server',
  all: 'All',
  incoming: 'Incoming',
  outgoing: 'Outgoing',
  currentVersion: 'Current Version',
  previousVersion: 'Previous Version',
  printerID: 'Printer ID',
  lastLoggedinOn: 'Last Logged in on',
  orderSubmission: 'Order Submission Allowed From',
  externalId: 'External ID',
  licenseID: 'License ID',
  confirmationText: 'Do you want to deactive?',
  activationText: 'Would you like to activate this webshop?',
  catalogActivationText: 'Would you like to activate this catalog?',
  licenseActivationText: 'Would you like to activate this license?',
  default: 'Default',
  rgu: 'RGU',
  sourceSystem: 'Source System',
  orderType: 'Order Type',
  printType: 'Print Type',
  autoPrinting: 'Auto Printing',
  pricingGroups: 'Pricing Groups',
  moon: 'moon',
  webshop: 'webshop',
  buildOverview: 'Build overview',
  generateInvoice: 'Generate invoice',
  massRemoveViews: 'Are you sure you want to remove this View? Deleting it will remove it from all existing items.',
  maxDeliveryDisWarning: 'Attention: please take into account that setting max delivery distance to 0 turns on delivery without any (!) limitations.',
  accountImpactWarning: 'Attention: the local admin rights shall be carefully assigned and only to customer accounts as it will impact Sun Front-End behavior.',
  sendToMoonWarning: 'Please make sure to set up a Moon instance with an active license as otherwise orders can not be processed.',
  detailed: 'Detailed',
  noVATtax: 'no VAT tax',
  noTipTax: 'No tip tax',
  noDeliveryTax: 'No delivery tax',
  noServiceTax: 'No service tax',
  deliveryDurationFrom: 'Delivery duration from (in min)',
  deliveryDurationTo: 'Delivery duration to (in min)',
  statusCode: 'Status Code',
  activateAfterCopy: 'Activate Catalog After Copy',
  primaryCompany: 'Primary Company',
  contactServerSettings: 'Contact server',
  addressServerSettings: 'Address server',
  walletServerSettings: 'Wallet server',
  depServerSettings: 'DEP Server',
  inventoryServerSettings: 'Inventory server',
  contactServerKey: 'Contact server key',
  addressServerKey: 'Address server key',
  walletServerKey: 'Wallet server key',
  depServerKey: 'DEP Server key',
  inventoryServerKey: 'Inventory server key',
  enableDEP: 'DEP enable',
  latitude: 'Latitude',
  longitude: 'Longitude',
  dailyOrdersCounterEnabled: 'Enable daily orders counter',
  cashRegisterName: 'Cash Register Name',
  cashRegisterId: 'Cash Register ID',
  depAccessKey: 'DEP access key',
  corporation: 'Corporation',
  aesKey: 'AES key',
  aesKeyCheckSum: 'AES key checksum',
  inUseFrom: 'In use from',
  storeId: 'Store ID',
  addHtml: 'Add new Html Hint',
  imageName: 'Image Name',
  imageId: 'Image ID',
  distanceUnit: 'Distance Unit',
  en: 'English',
  de: 'German',
  zh: 'Chinese',
  registrationNumber: 'Registration number',
  registrationLocation: 'Registration location',
  bookKeeperEmails: 'Book keeper Recipients Email (separated by ,)',
  visibleToCustomer: 'Visible to customer',
  massRemoveAllergens: 'Are you sure you want to remove this Allergen? Deleting it will remove it from all existing items.',
  importHtml: 'Import Html Hints',
  enableKitchenPrintPersistence: 'Enable kitchen print persistence',
  numberOfSeats: 'Number of Seats',
  addProperty: 'Add new Property',
  importProperty: 'Import Properties',
  foreignId: 'Foreign ID',
  dailyOrderCounterPrefixes: 'Daily Order Counter Prefixes',
  delivery: "Delivery",
  collection: "Collection",
  takeaway: "Takeaway",
  card: 'Card',
  cash: 'Cash',
  amazon: 'Amazon',
  cardmanual: 'Card Manual',
  deliveroo: 'Deliveroo',
  hungryhouse: 'Hungry House',
  invoice: 'Invoice',
  justeat: 'Justeat',
  ubereats: 'Ubereats',
  voucher: 'Voucher',
  galaxycard: 'Galaxy Card',
  webshopOrderNo: 'Webshop Order #',
  appOrderNo: 'OrderApp Order #',
  webshopTotal: 'Webshop Total Amount',
  appTotal: 'OrderApp Total Amount',
  authServerSettings: 'Auth Server',
  publiclyAvailable: 'Publicly Available',
  reservationServerSettings: 'Reservation Server',
  addressLookup: 'Address Lookup',
  postalCode: 'Postal code',
  line1: 'Line 1',
  line2: 'Line 2',
  line3: 'Line 3',
  line4: 'Line 4',
  line3AT: 'Staircase/apartment/Address details',
  line2AT: 'House number',
  line1AT: 'Street',
  acceptingOrders: 'Accept orders (disable to temporary stopping accepting orders)',
  labelPrint: 'Label print',
  askDetails: 'Ask details',
  vatPrint: 'VAT print',
  noDiscount: 'No discount applicable',
  addsGalaxyCardBalance: 'Adds Galaxy Card balance',
  quantityOfIncludedOptions: 'Quantity Of Included Options',
  restaurant: "Restaurant",
  defaultPaymentType: 'Default Payment Type',
  notifyOwnerOnPaymentFailure: 'Notify Owner On Payment Failure',
  webshopUrl: 'Webshop Url',
  copy: 'Copy',
  apiKey: 'API Key',
  nfcToken: 'NFC Token',
  passwordResetPrefixText: 'Please select a payment gateway provider, enter the basic data and save the record to trigger the key generation. Please wait and refresh the screen in order to enable password entry.',
  printTemplateActivationText: 'Would you like to activate this print template?',
  activateShopFirst: 'Please activate the webshop first. Then you will be able to set up a payment gateway.',
  timezone: 'Timezone',
  upload: 'Chose file',
  predefinedViews: 'Add predefined view',
  showEmail: 'Show email',
  showPhoneNumber: 'Show phone number',
  smsConfirmationFirstOrder: 'SMS confirmation first order',
  smsUsername: 'SMS username',
  smsSettings: 'Sms Settings',
  discountSettings: 'Discount Settings',
  updateSmsPassword: 'Set/Update Sms Password',
  passwordSmaResetPrefixText: 'Please enable Sms confirmation first order, add username and save the record to enable password set. Please wait and refresh the screen in order to enable password entry.',
  generalSettings: 'General Settings',
  terminalName: 'Terminal Name',
  terminalId: 'Terminal ID',
  terminalIdentifier: 'Terminal Identifier',
  paymentServerName: 'Payment Server Name',
  depReceipts: 'Dep Receipts',
  delChargePerMeter: 'Delivery Charge Per Meter',
  publicHoliday: 'PUBLIC HOLIDAY',
  allChildren: 'All children',
  paymentTerminals: 'Payment Terminals',
  paymentServers: 'Payment Servers',
  frontEndVersion: 'Frontend',
  backendversion: 'Backend',
  webshopQr: 'Webshop QR',
  contactTrackingQr: 'Contact tracking QR',
  menuQr: 'Menu QR',
  connectEApiKey: 'Api Key',
  connectEUsername: 'Username',
  signUp: 'Sign-up',
  confirmEmail: 'Confirm Email',
  account: 'Account',
  selectedAddress: 'Selected Address',
  none: 'None',
  atUser: 'AT User',
  atLocalAdmin: 'AT Local Admin',
  merchantPrint: 'Merchant print',
  customerPrint: 'Customer print',
  automaticPrint: 'Automatic Printing',
  maxDiscountPercentage: 'Max Discount Percentage',
  merchant: 'Merchant',
  customer: 'Customer',
  switchReceiptType: 'First Receipt Type',
  selectCompany: 'Select company',
  filterCategories: 'Filter categories',
  name1: 'Name',
  printerCategories: 'Printer categories',
  settings: 'Settings',
  VAT: 'VAT',
  taxCategory: 'Tax category',
  defPrice: 'Def. price',
  choseLabelToAddImage: 'Chose label to add image',
  selectLabelFirst: 'Select label first',
  selectImage: 'Select Image',
  inputLanguage: 'Input language',
  outputLanguage: 'Output language',
  parentCopy: 'Copy all children from selected source',
  views: 'Views',
  size: 'Size',
  variant: 'Variant',
  option: 'Option',
  style: 'Style',
  parentCopyFrom: 'Parent from where the children should be copied from',
  includedQuantity: 'Included Quantity'
}



// WEBPACK FOOTER //
// ./src/lang/en/labels.js